import { Flex, Text } from '@mantine/core'

import BaseIcon from '@/components/basic/BaseIcon'
import PriceChange from '@/components/PriceChange'
import { HighlightedCoin } from '@/services/category'

import styles from './styles.module.css'

export default function CategoryCoin({ coin }: { coin: HighlightedCoin }) {
  const { name, symbol, percent_change_24h_native, icon_image_url } = coin
  const priceChange = Number(percent_change_24h_native) * 0.01 || 0

  return (
    <Flex className={styles.coinItemContainer} gap={8}>
      <Flex align="center" gap={8}>
        <BaseIcon
          src={icon_image_url ?? undefined}
          size={20}
          fallbackText={name}
          alt={symbol}
          circle
        />
        <Text variant="body" c="var(--content-secondary)" truncate className={styles.coinSymbol}>
          {symbol}
        </Text>
      </Flex>
      <PriceChange value={priceChange} variant="body-emphasis" />
    </Flex>
  )
}
